import { ProductHeading } from './ProductHeading';
import { ProductPrice } from './ProductPrice';
import { ProductSummary } from './ProductSummary';
import { ProductSpecPicker } from './ProductSpecPicker';
import { ProductCartCounter } from './ProductCartCounter';
import { ProductCartButtons } from './ProductCartButtons';

export const SSR = {
    ProductHeading,
    ProductPrice,
    ProductSummary,
    ProductSpecPicker,
    ProductCartCounter,
    ProductCartButtons,
};
